import { useEffect, useState } from "react";
import UserReportInfoView from "./UserReportInfoView";
import { CalendarGreyIcon, InfoBlackIcon, LocationGreyIcon, UserGreyIcon } from "../../../assets/icons";
import { UserReportTableInfoDTO } from "../../../models/userReport/userReport.response";
import { useNotification } from "../../toster-notification/NotificationContext";
import Loader from "../../shared/Loader";
import { getUserReportStatusTypeToString, UserReportStatusType } from "../../../models/base/UserReportStatusType";
import { UserReportReasonType, getUserReportReasonTypeToString } from "../../../models/base/UserReportReasonType";
import { UserReportsService } from "../../../services/userReportsService";
import { ToLocalDateString } from "../../../utils/dateFormater";



const UserReportsPage: React.FC = () => {

    const [isReportInfoOpen, setIsReportInfoOpen] = useState<boolean>(false);

    const [reports, setReports] = useState<UserReportTableInfoDTO[]>([]);
    const [selectedReportId, setSelectedReportId] = useState<string>("");

    const [filterStartDate, setFilterStartDate] = useState<string>("");
    const [filterEndDate, setFilterEndDate] = useState<string>("");
    const [filterStatus, setFilterStatus] = useState<UserReportStatusType | "">("");
    const [filterReasonType, setFilterReasonType] = useState<UserReportReasonType | "">("");
    const [filterText, setFilterText] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();


    useEffect(() => {
        fetchReports();
    }, []);


    const fetchReports = async () => {
        setLoading(true);
        try {
            const response = await UserReportsService.getUserReports(filterStartDate, filterEndDate, filterStatus as UserReportStatusType, filterReasonType as UserReportReasonType);
            if (response.success && response.data) {
                setReports(response.data);
            } else {
                notify("error", "Nije moguće učitati prijave korisnika.");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja prijava.");
        } finally {
            setLoading(false);
        }
    };

    const handleResetFilters = () => {
        setFilterStartDate("");
        setFilterEndDate("");
        setFilterStatus("");
        setFilterReasonType("");
        setFilterText("");
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {isReportInfoOpen &&
                <UserReportInfoView
                    id={selectedReportId}
                    onClose={() => setIsReportInfoOpen(false)}
                />
            }
            <section className="sa-settings-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Prijave korisnika</h2>
                                <div className="text-block">Pregled svih prijava zlonamernih korisnika od strane admina lokala</div>
                            </div>
                        </div>
                        <div className="list-stats-block-div">
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Ukupno</div>
                                    <div className="list-stats-number-text">{reports.length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Na čekanju</div>
                                    <div className="list-stats-number-text red">{reports.filter((r) => r.status === UserReportStatusType.Pending).length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Pregledano</div>
                                    <div className="list-stats-number-text blue">{reports.filter((r) => r.status === UserReportStatusType.UnderReview).length}</div>
                                </div>
                            </div>
                            <div className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Rešeno</div>
                                    <div className="list-stats-number-text green">{reports.filter((r) => r.status === UserReportStatusType.Resolved).length}</div>
                                </div>
                            </div>
                            <div id="w-node-f62dd697-178f-cfdf-0d56-992ab3ce9a49-7969b2d6" className="admin-settings-box-div height-120px">
                                <div className="sa-subscription-active-info">
                                    <div>Odbijeno</div>
                                    <div className="list-stats-number-text red">{reports.filter((r) => r.status === UserReportStatusType.Rejected).length}</div>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div">
                            <div className="fs-1rem">Filteri</div>
                            <div className="w-form">
                                <form className="form-8">

                                    <div className="filter-div">
                                        <div className="description-text">Pretraga</div>
                                        <input className="form-input w-input" placeholder="Pretraga po korisniku" type="text"
                                            value={filterText}
                                            onChange={(e) => setFilterText(e.target.value)}
                                        />
                                    </div>

                                    <div className="filter-div">
                                        <div className="description-text">Datum od</div>
                                        <input className="form-input grey w-input" type="date"
                                            value={filterStartDate}
                                            onChange={(e) => setFilterStartDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="filter-div">
                                        <div className="description-text">Datum do</div>
                                        <input className="form-input grey w-input" type="date"
                                            value={filterEndDate}
                                            onChange={(e) => setFilterEndDate(e.target.value)}
                                        />
                                    </div>

                                    <div className="filter-div">
                                        <div className="description-text">Status</div>
                                        <select className="form-select auto-width w-select"
                                            value={filterStatus}
                                            onChange={(e) => setFilterStatus(e.target.value as UserReportStatusType | "")}
                                        >
                                            <option value="">Bilo koji</option>

                                            {Object.values(UserReportStatusType)
                                                .filter((value) => typeof value === "number")
                                                .map((value) => (
                                                    <option key={value} value={value}>
                                                        {getUserReportStatusTypeToString(value as UserReportStatusType)}
                                                    </option>
                                                ))}

                                        </select>
                                    </div>

                                    <div className="filter-div">
                                        <div className="description-text">Razlog</div>
                                        <select className="form-select auto-width w-select"
                                            value={filterReasonType}
                                            onChange={(e) => setFilterReasonType(e.target.value as UserReportReasonType | "")}
                                        >
                                            <option value="">Bilo koji</option>

                                            {Object.values(UserReportReasonType)
                                                .filter((value) => typeof value === "number")
                                                .map((value) => (
                                                    <option key={value} value={value}>
                                                        {getUserReportReasonTypeToString(value as UserReportReasonType)}
                                                    </option>
                                                ))}

                                        </select>
                                    </div>

                                </form>
                            </div>
                            <div className="filter-bottom-div">
                                <div className="fs-1rem description-text">
                                    Prikazano: <span className="text-span-7">{reports.length}</span>
                                    {/* od 9 rezervacija */}
                                </div>
                                <div className="filter-bouttons-div">
                                    <div className="small-box-div transparent-border pointer" onClick={handleResetFilters}>
                                        <div>Resetuj</div>
                                    </div>
                                    <div className="small-box-div light-blue-bg pointer height-35px width-200px" onClick={fetchReports}>
                                        <div>Primeni filtere</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="reported-users-list-div">

                            {reports
                                .filter((report) => {
                                    const searchText = filterText.toLowerCase();
                                    return (report.reportedUserFullName.toLowerCase().includes(searchText) ||
                                        report.reportedUserPhoneNumber.toLowerCase().includes(searchText));
                                })
                                .map((report) => (
                                    <div className="reported-user-div" key={report.id}>
                                        <div className="reported-user-header-block">
                                            <div className="reported-user-header-div">
                                                <div className="description-text">#{report.id}</div>
                                                <div className="small-box-div">
                                                    <div>{getUserReportStatusTypeToString(report.status)}</div>
                                                </div>
                                                <div>{getUserReportReasonTypeToString(report.reasonType)}</div>
                                            </div>
                                            <div className="reported-user-open-info-div">
                                                <img src={InfoBlackIcon} loading="lazy" alt="" className="icon-size-28 pointer"
                                                    onClick={() => {
                                                        setSelectedReportId(report.id);
                                                        setIsReportInfoOpen(true);
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="reported-user-user-info-div">
                                            <div className="fs-1-125rem bold">{report.reportedUserFullName}</div>
                                            <div className="description-text">{report.reportedUserPhoneNumber}</div>
                                        </div>
                                        <div className="description-text">{report.description}</div>
                                        <div className="reported-user-reporting-info-block">
                                            <div className="reported-user-reporting-info">
                                                <img src={LocationGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                <div className="description-text">{report.localName}</div>
                                            </div>
                                            <div className="reported-user-reporting-info">
                                                <img src={UserGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                <div className="description-text">Prijavio: {report.reportedByUserFullName}</div>
                                            </div>
                                            <div className="reported-user-reporting-info">
                                                <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                <div className="description-text">{ToLocalDateString(report.createdAt.toString())}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default UserReportsPage;